import React from 'react';

import CustomModal from '../../components/CustomModal';
import ExternalLink from '../../components/ExternalLink';
import { CrossIcon, SuccessIcon } from '../../assets/icons';
import Button from '../../components/Button';
import useModalState from '../../context/modal/useModalState';
import { useWeb3React } from '@web3-react/core';
import { CHAIN_INFO, SupportedChains } from '../../config/constants';

const SuccessModal: React.FC = () => {
    const { chainId } = useWeb3React();
    const { modalData, closeModal } = useModalState();
    const onClose = () => closeModal('successModal');

    return (
        <CustomModal
            modalName='successModal'
            className='success-modal status-modal'
            overlayClassName='status-modal'
        >
            <div className='content'>
                <Button onClick={onClose}>
                    <CrossIcon />
                </Button>
                <div className='icon-container'>
                    <SuccessIcon />
                </div>
                <div
                    className='status'
                    dangerouslySetInnerHTML={{ __html: modalData?.status }}
                />
                {modalData?.message ? (
                    <div className='message'>{modalData?.message}</div>
                ) : null}
                {modalData?.txHash ? (
                    <div className='link'>
                        <ExternalLink
                            to={`${
                                CHAIN_INFO[chainId as SupportedChains]?.blockExplorer
                            }/tx/${modalData.txHash}`}
                        >
                            Show transaction in block explorer
                        </ExternalLink>
                    </div>
                ) : null}
            </div>
        </CustomModal>
    );
};

export default SuccessModal;
